import {
    LOAD_INDUCT_PACKAGE_METRICS_FOR_SORT_ZONE,
    LOAD_METRICS_FOR_SORT_ZONE_CALL_BEGIN,
    LOAD_METRICS_FOR_SORT_ZONE_CALL_FAILURE,
    LOAD_NODE_RESOURCE_DATA_FOR_SORT_ZONE,
    LOAD_STOW_BAG_DATA_FOR_SORT_ZONE,
    LOAD_STOW_BAG_METRICS_FOR_SORT_ZONE,
    LOAD_STOW_OV_USAGE_FOR_SORT_ZONE,
    LOAD_STOW_PACKAGE_METRICS_FOR_SORT_ZONE, LOAD_TOTAL_SORT_ZONE
} from "../actions/SortZoneActions";

/**
 * Initial state of the system.
 */
const initialState = {
    loading: true,
    stowPackageMetricsMap: {},
    stowBagMetricsMap: {},
    stowOvUsageMap: {},
    inductPackageMetricsMap: {},
    bagsData: {},
    totalSortZoneMap: {}
}

/**
 * Reducer function for Sort Zone View that changes state
 * based on the action triggered.
 */
export default function sortZoneReducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_METRICS_FOR_SORT_ZONE_CALL_BEGIN:
            return {
                ...state,
                loading: true
            }
        case LOAD_STOW_PACKAGE_METRICS_FOR_SORT_ZONE:
            return {
                ...state,
                loading: false,
                stowPackageMetricsMap: action.stowPackageMetricsMap
            };
        case LOAD_STOW_BAG_METRICS_FOR_SORT_ZONE:
            return {
                ...state,
                loading: false,
                stowBagMetricsMap: action.stowBagMetricsMap
            };
        case LOAD_INDUCT_PACKAGE_METRICS_FOR_SORT_ZONE:
            return {
                ...state,
                loading: false,
                inductPackageMetricsMap: action.inductPackageMetricsMap
            };
        case LOAD_STOW_OV_USAGE_FOR_SORT_ZONE:
            return {
                ...state,
                loading: false,
                stowOvUsageMap: action.stowOvUsageMap
            };
        case LOAD_STOW_BAG_DATA_FOR_SORT_ZONE:
            return {
                ...state,
                loading: false,
                bagsData: {
                    ...state.bagsData,
                    [action.stowBagsData.sortZone]: action.stowBagsData.bagsData
                }
            };
        case LOAD_NODE_RESOURCE_DATA_FOR_SORT_ZONE:
            return {
                ...state,
                loading: false,
                nodeResourceData: action.nodeResourceData
            };
        case LOAD_METRICS_FOR_SORT_ZONE_CALL_FAILURE:
            return {
                ...state,
                loading: false
            }
        case LOAD_TOTAL_SORT_ZONE :
            return {
                ...state,
                loading :false,
                totalSortZoneMap : action.totalSortZoneMap
            }

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/SortZoneReducer.js